import request from './request'

export function listMasterOrder(data) {
  return request.post('/sales/master-orders/list', data)
}
export function getMasterOrder(id) {
  return request.get('/sales/master-orders/' + id)
}
export function saveMasterOrder(data) {
  return request.post('/sales/master-orders', data)
}
export function updateMasterOrder(data) {
  return request.post('/sales/master-orders/update', data)
}
export function deleteMasterOrder(ids) {
  return request.post('/sales/master-orders/delete', ids)
}
export function confirmMasterOrder(id) {
  return request.post('/sales/master-orders/confirm', { masterOrderId: id })
}
export function unconfirmMasterOrder(id) {
  return request.post('/sales/master-orders/unconfirm', { masterOrderId: id })
}
export function generateProductionOrders(id, lineIds) {
  return request.post('/sales/master-orders/generate', { masterOrderId: id, lineIds: lineIds || null })
}
